import MessageBox from "@/components/common/messagebox/MessageBox.vue";
import ModalContact from "@/components/company/contacts/form/ModalContact.vue";
import message from "@/components/common/message/Message.vue";
import TableField from "@/components/common/table-field/TableField.vue";
export default {
    name: 'Contacts',
    props: ['companyId'],

    components: {
        TableField,
        message,
        MessageBox,
        ModalContact
    },

    data() {
        return {
            loading: false,
            contacts: [],
            isVisibleMsg: false,
            message: null,
            isMsg: null,
            params: {
                page: 1,
                pageSize: this.getPageSize(),
                total: 0,
                sort_column: null,
                sort_direction: null,
                search: null
            }
        }
    },

    computed: {
        columns() {
            return [
                { title: this.$t('client.first_name'), key: "first_name", sortable: true },
                { title: this.$t('client.last_name'), key: "last_name", sortable: true },
                { title: this.$t('client.phone'), key: "phone", sortable: true },
                { title: this.$t('client.email'), key: "email", sortable: true },
                { title: this.$t('client.comment'), key: "comment", sortable: true },
                {
                    key: "actions",
                    minWidth: "200px",
                    actions: [
                        { emit: "onEdit", icon: "bi bi-pencil-square", class: "btn-sm btn-success", tooltip: "Edit" },
                        { emit: "sendMessageDestroy", icon: "bi bi-trash3", class: "btn-sm btn-danger", tooltip: "Delete" }
                    ]
                }
            ]
        }
    },

    methods: {
        getPageSize() {
            const pageSize = localStorage.getItem('contacts-page-size');
            return pageSize ? Number(pageSize) : 20;
        },

        async populateData() {
            this.loading = true;
            try {
                const response = await this.getContacts();
                if (!response || response.error || response.canceled) return;
                const { data, pagination } = response;
                this.contacts = this.BasicHelper.cloneObject(data.contacts);
                this.params = {
                    ...this.params,
                    ...pagination
                }
            } finally {
                this.loading = false;
            }
        },

        async getContacts() {
            return this.ApiRequest.requestAsync(
                `company/contacts/${this.companyId}`,
                this.ApiRequest.REQUEST_POST,
                this.params,
                'company-contacts',
                true
            );
        },

        handleAction({ type, row }) {
            if (type === 'onEdit') {
                this.onEdit(row);
            } else if (type === 'sendMessageDestroy') {
                this.sendMessageDestroy(row);
            }
        },

        async sendMessageDestroy (el, approved = false) {
            if (approved) {
                this.loading = true;
                try {
                    const { data } = await this.onDestroyContact(el.ContactPersonId);
                    if (data && data.success) {
                        this.isVisibleMsg = true;
                        this.isMsg = 'success';
                        this.message = this.$t('client.destroy_successfully');
                        this.populateData();
                    }
                } finally {
                    this.loading = false;
                }
            } else {
                this.$refs.destroyMsgBox.show(el, '', this.$t('client.msg_destroy'));
            }
        },

        onDestroyContact (contactId) {
            return this.ApiRequest.requestAsync(
                `company/contacts/destroy/${contactId}`,
                this.ApiRequest.REQUEST_GET,
                [],
                'company-contacts-destroy',
                true
            );
        },

        onStoreContact () {
            this.populateData();
            this.isVisibleMsg = true;
            this.isMsg = 'success';
            this.message = this.$t('client.store_successfully');
        },

        changeIsVisibleMsg(isVisible) {
            this.isVisibleMsg = isVisible;
        },

        create() {
            this.$refs.showModalContact.show({'client_id': this.companyId}, this.$t('contact.creating-title'));
        },

        onEdit(contact) {
            contact.client_id = this.companyId;
            this.$refs.showModalContact.show(contact, this.$t('contact.edit-title'));
        }
    },

    beforeMount() {
        this.populateData();
    }
}
